module.exports = __webpack_public_path__ + "img/update.0b26b9f1.png";